import type { UserItem } from '../types/items';
import type { BattleEffect } from '../types/battle';

export function calculateItemEffect(item: UserItem): BattleEffect {
  // Base effect based on item type
  switch (item.type) {
    case 'food':
      return {
        type: 'heal',
        value: item.stats.healing || 20,
        description: `Used ${item.name} to heal for ${item.stats.healing || 20} HP`
      };

    case 'weapon':
      const damage = item.stats.strength || 10;
      return {
        type: 'damage',
        value: damage,
        description: `Used ${item.name} to deal ${damage} damage`
      };

    case 'armor':
      const shield = item.stats.vitality || 15;
      return {
        type: 'shield',
        value: shield,
        duration: 2,
        description: `Used ${item.name} to gain ${shield} shield`
      };

    case 'accessory':
      // Accessories can provide mixed effects
      const effects: BattleEffect[] = [];
      if (item.stats.healing) {
        effects.push({
          type: 'heal',
          value: item.stats.healing,
          description: `${item.name} restored ${item.stats.healing} HP`
        });
      }
      if (item.stats.vitality) {
        effects.push({
          type: 'shield',
          value: item.stats.vitality,
          duration: 2,
          description: `${item.name} provided ${item.stats.vitality} shield`
        });
      }
      return effects[0] || {
        type: 'heal',
        value: 10,
        description: `Used ${item.name}`
      };

    default:
      return {
        type: 'heal',
        value: 10,
        description: `Used ${item.name}`
      };
  }
}